// 消息
export default {
    noNews: 'Пока больше новостей нет',
    TINO: 'Больше нет',
    historicalNews: 'Исторические новости',
    time: 'время'
}